import studiesConst from '@/constants/studiesConst';
import PropTypes from 'prop-types';

export default function AssessmentStatusBadge({status}) {
  switch (status) {
    case studiesConst.moduleStatus.inProgress:
      return (
        <div className="status-field">
          <span className="ellipse figure--gray" />
        </div>
      );
    case studiesConst.moduleStatus.completed:
    case studiesConst.moduleStatus.inReview:
      return (
        <div className="status-field">
          <span className="ellipse figure--blue" />
        </div>
      );
    case studiesConst.moduleStatus.accepted:
      return (
        <div className="status-field">
          <span className="ellipse figure--green" />
        </div>
      );
    case studiesConst.moduleStatus.partiallyAccepted:
      return (
        <div className="status-field">
          <span className="ellipse figure--yellow" />
        </div>
      );
    case studiesConst.moduleStatus.rejected:
      return (
        <div className="status-field">
          <span className="ellipse figure--red" />
        </div>
      );
    case studiesConst.moduleStatus.pendingCancel:
      return (
        <div className="status-field">
          <span className="ellipse figure--mint" />
        </div>
      );
    case studiesConst.moduleStatus.invalid:
      return (
        <div className="status-field">
          <span className="ellipse figure--strong-gray" />
        </div>
      );
    default:
      return (
        <div className="status-field">
          <span className="ellipse figure--white" />
        </div>
      );
  }
}

AssessmentStatusBadge.propTypes = {
  status: PropTypes.number,
};
